// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from 'jquery';
import 'slick-carousel';
import AOS from 'aos';

(function () {
    'use strict';
})();

$(function () {
    function updateHeroPadding() {
        var navbarHeight = $('.navbar').outerHeight();
        $('.hero').css('--top-spacing', navbarHeight + 'px');
    }
    updateHeroPadding();
    $(window).on('resize', function () {
        updateHeroPadding();
    });

    $('.questions').slick({
        infinite: true,
        slidesToShow: 3, // Domyślna liczba slajdów dla dużych ekranów
        arrows: true,
        dots: false,
        swipeToSlide: true,
        prevArrow: $('.slick-btn-back'),
        nextArrow: $('.slick-btn-next'),
        responsive: [
            {
                breakpoint: 1024, // Tablet: punkty poniżej 1024px
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 600, // Telefon: punkty poniżej 600px
                settings: {
                    slidesToShow: 1,
                    adaptiveHeight: true,
                },
            },
        ],
    });
    AOS.init({
        disable: function () {
            var maxWidth = 576;
            return window.innerWidth < maxWidth;
        },
    });

    // Formularz

    // Synchronizacja kwoty na stronie głównej i w modalu
    function formatNumberToPolishLocale(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    function updateGradient(value) {
        var percentage = ((value - $('.range-input').attr('min')) / ($('.range-input').attr('max') - $('.range-input').attr('min'))) * 100;
        $('.range-status').css('background', `linear-gradient(to right, #952e4e ${percentage}%, rgba(255, 255, 255, 0) ${percentage}%)`);
    }

    function updateGradientAndValue(selectorPrefix, value) {
        var percentage = ((value - $(`${selectorPrefix} .range-input`).attr('min')) / ($(`${selectorPrefix} .range-input`).attr('max') - $(`${selectorPrefix} .range-input`).attr('min'))) * 100;
        $(`${selectorPrefix} .range-status`).css('background', `linear-gradient(to right, #952e4e ${percentage}%, rgba(255, 255, 255, 0) ${percentage}%)`);
        var formattedValue = formatNumberToPolishLocale(value);
        $(`${selectorPrefix} .input-cash`).val(formattedValue);
    }

    function formatPLN(value) {
        return value.toLocaleString('pl-PL', {minimumFractionDigits: 0, maximumFractionDigits: 0}).replace(/\u00A0/g, ' ') + ' PLN';
    }

    function calculateRates() {
        var termTile = $('.month-wrapper .tile.active');
        var termData = termTile.data('value');
        var term = parseInt(termData) || 6;

        var netAmount = parseFloat($('.range-input').val()) || 0;

        var costPercentage;
        switch (term) {
            case 6:
                costPercentage = 18;
                break;
            case 9:
                costPercentage = 24;
                break;
            case 12:
                costPercentage = 29;
                break;
            case 18:
                costPercentage = 47;
                break;
            case 21:
                costPercentage = 52;
                break;
            case 24:
                costPercentage = 58;
                break;
            default:
                costPercentage = 29;
        }

        var grossAmount = netAmount + (netAmount * costPercentage) / 100;
        var monthlyRate = netAmount * 0.0112;
        var balloonRate = grossAmount - (term - 1) * monthlyRate;
        $('.monthly-instalment .value').html(formatPLN(monthlyRate));
        $('.balloon-sum .value').html(formatPLN(balloonRate));
    }

    $('.range-input').on('input', function () {
        calculateRates();
        var activeTile = $('.month-wrapper .tile.active');
        var dataValue = activeTile.data('value');
        var months = parseInt(dataValue) || 6;

        var value = $(this).val();
        var selectorPrefix = $(this).closest('.set-1').length > 0 ? '.set-1' : '.set-2';
        var otherSelectorPrefix = selectorPrefix === '.set-1' ? '.set-2' : '.set-1';
        updateGradientAndValue(selectorPrefix, value);
        $(`${otherSelectorPrefix} .range-input`).val(value);
        updateGradientAndValue(otherSelectorPrefix, value);
        $('#input_2_1').val(formatNumberToPolishLocale(value) + ' PLN');
        $('#input_2_3').val(months);
    });
    var defaultValue = $('#rangeInput').val();
    $('.input-cash').val(formatNumberToPolishLocale(defaultValue));
    updateGradient(defaultValue);

    $('.input-cash').on('input', function () {
        var valueString = $(this).val().replace(/\s+/g, ''); // Usuwamy spacje
        var value = parseInt(valueString, 10); // Konwersja string na liczbę

        // Ograniczenie wartości do maksymalnie 1 000 000
        value = value > 1000000 ? 1000000 : value;

        if (!isNaN(value)) {
            // Sprawdzenie, czy wartość jest liczbą
            var selectorPrefix = $(this).closest('.set-1').length > 0 ? '.set-1' : '.set-2';
            var otherSelectorPrefix = selectorPrefix === '.set-1' ? '.set-2' : '.set-1';

            // Aktualizacja wartości suwaka dla obu zestawów
            $(`${selectorPrefix} .range-input`).val(value);
            updateGradientAndValue(selectorPrefix, value);

            $(`${otherSelectorPrefix} .range-input`).val(value);
            updateGradientAndValue(otherSelectorPrefix, value);

            // Aktualizacja pola input, aby odzwierciedlić formatowanie i ewentualne ograniczenia wartości
            $(this).val(formatNumberToPolishLocale(value.toString()));
        }
    });

    // Synchronizacja ilości miesięcy na stronie głównej i w modalu
    $('.tile').on('click', function () {
        $('.tile').removeClass('active');
        var value = $(this).data('value');
        $('.tile[data-value="' + value + '"]').addClass('active');
        calculateRates();
        $('#input_2_3').val(value);
    });

    // Obsługa zmiany #input_2_10_1
    function attachCheckboxListeners() {
        $('#input_2_10_1').change(function () {
            if ($(this).is(':checked')) {
                $('#input_2_7_1, #input_2_8_1, #input_2_9_1').prop('checked', true);
            }
        });
    }

    // Funkcja do dodania nasłuchiwania
    function attachCheckboxListeners() {
        const mainCheckbox = document.querySelector('#input_2_10_1');
        if (mainCheckbox) {
            mainCheckbox.addEventListener('change', function () {
                if (this.checked) {
                    document.querySelectorAll('#input_2_7_1, #input_2_8_1, #input_2_9_1').forEach(function (checkbox) {
                        checkbox.checked = true;
                    });
                }
            });
        }
    }

    // MutationObserver do nasłuchiwania zmian w DOM
    const observer2 = new MutationObserver(() => {
        const formElement = document.querySelector('#gform_wrapper_2'); // Zmień 2 na ID Twojego formularza
        if (formElement) {
            attachCheckboxListeners();
        }
    });

    observer2.observe(document.body, {childList: true, subtree: true});

    // Wywołanie przy pierwszym załadowaniu strony
    document.addEventListener('DOMContentLoaded', attachCheckboxListeners);

    // $(document).on('gform_post_render', function (event, formId) {
    //     if (formId == 1) {
    //         $('#form-loader').hide();
    //     }
    // });
    // $(document).on('gform_confirmation_loaded', function (event, formId) {
    //     if (formId == 2) {
    //         $('.element-after-hide').hide();
    //     }
    // });

    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.classList && node.classList.contains('gform_confirmation_wrapper')) {
                    console.log('.gform_confirmation_wrapper is visible');
                    myCustomFunction();
                    observer.disconnect(); // Zatrzymaj obserwatora
                }
            });
        });
    });

    // Rozpocznij obserwację całego dokumentu
    observer.observe(document.body, {childList: true, subtree: true});

    // Funkcja do wykonania po pojawieniu się elementu
    function myCustomFunction() {
        $('.element-after-hide').hide();
    }
});
